import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';

@Component({
    selector: 'app-sorry',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './sorry.component.html',
    styleUrl: './sorry.component.scss',
})
export class SorryComponent {
    sorryTitle = 'features.sorry.sorryTitle';
    sorrySubTitle = 'features.sorry.sorrySubTitle';
    sorryInfo = 'features.sorry.sorryInfo';

    isPortraitDevice = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private changeStepService: ChangeStepService,
    ) {
        this.changeStepService.changeStep(0);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });
    }
}
